import { Selection } from "../../contracts";

export const sortIceHockeyBothTeamToScore = (x: Selection, y: Selection) =>
{
    return x.id.endsWith("Q20") ? -1 : 1;
}